import mixpanel from 'mixpanel-browser';

// TODO: De-duplicate window.materio.mixpanel.projectToken with the token in
//   the AppRootContext. Main challenge is deciding how early to init mixpanel
//   (have to consider legacy callers that call window.mixpanel very early,
//   before react is mounted).
export function initMixpanelStepOne() {
  if (!window.materio?.mixpanel?.enabled) {
    return; // No-Op; MixPanel is disabled
  }

  mixpanel.init(window.materio.mixpanel.projectToken, {
    track_pageview: 'url-with-path',
    persistence: 'localStorage',
    debug: window.materio.mixpanel.debug ?? false,
  });

  // Backwards-compatibility; older code may call window.mixpanel directly
  window.mixpanel = mixpanel;
}
